module.exports = __webpack_public_path__ + "img/AI.39a36fc0.png";